import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header-nav',
  templateUrl: './header-nav.component.html',
  standalone: false,
})
export class HeaderNavComponent {
  @Input() menu: any;
  activeParent: HTMLElement;

  constructor(
    private router: Router //router here is used in html
  ) {}

  openParentMenu(event: Event) {
    const target = event.target as HTMLElement;
    this.activeParent = target.closest('.-link-items');
    if (this.activeParent) {
      this.activeParent.classList.toggle('-show-sub-menu');
    }
  }

  closeParentMenu() {
    this.activeParent.classList.toggle('-show-sub-menu');
  }
}
